import { render, staticRenderFns } from "./productcategory.vue?vue&type=template&id=66eaeadb&scoped=true&"
import script from "./productcategory.vue?vue&type=script&lang=js&"
export * from "./productcategory.vue?vue&type=script&lang=js&"
import style0 from "./productcategory.vue?vue&type=style&index=0&id=66eaeadb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eaeadb",
  null
  
)

export default component.exports